import React from "react";
import { useSelector } from "react-redux";

import Procedure from "./Procedure";
const RunProcedure = (props) => {
  const procedureRuntimeState = useSelector(
    (state) => state.workItems[props?.rowProp?.id]?.procedure
  );
  return <Procedure {...props} procedureRuntimeState={procedureRuntimeState} />;
  // return "Coming Soon!";
};

export { RunProcedure };
